<script>
import DeviceDetector from 'vue-device-detector';

export default {
    name: 'CpDownloadAppDialog',
    components: {
        CpButton: require('../button').default,
        CpDialogBottom: require('../dialog-bottom').default,
        CpBoxContent: require('../box-content').default,
        CpBox: require('../box').default,
    },
    props: {
        handleDialog: Function,
    },
    data() {
        return {
            iosApp: process.env.MIX_IOS_STORE_URL,
            androidApp: process.env.MIX_ANDROID_STORE_URL,
        };
    },
    methods: {
        handleDownload() {
        if (this.$device.ios) {
            window.location.href = this.iosApp;
        } else if (this.$device.android) {
            window.location.href = this.androidApp;
        }
    }
    },
    computed: {},
};
</script>
<template>
    <cp-dialog-bottom>
        <cp-box>
            <cp-box-content>
                <section>
                    <template class="share-container">
                        <h2 class="black-color textCenter headline">
                            With the CrowdBlue app, politics becomes even simpler. Try it now!
                        </h2>
                        <div class="btnContainer">
                            <cp-button style="marginRight: 10px;" @click="handleDialog" block>Maybe later</cp-button>
                            <cp-button primary @click="handleDownload" block>Download app</cp-button>
                        </div>
                    </template>
                </section>
            </cp-box-content>
        </cp-box>
    </cp-dialog-bottom>
</template>
<style scoped>
.share-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    max-width: 1000px;
    margin: auto;
}

.btnContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
}

.textCenter {
    text-align: center;
}
</style>
